import { combineReducers } from 'redux';

import partnerReducerMap, {
    selectors as partnerSelectors,
    actions as partnerActions,
} from './appstate';
import NAMESPACE from './types';

const reducer = combineReducers({
    ...partnerReducerMap,
});

export {
    partnerActions,
    partnerSelectors,
};

export default { [NAMESPACE]: reducer };
